/* eslint-disable object-curly-newline */
import React from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

interface ToListButtonProps {
    navigateUrl: string;
    preNavigate?: () => void;
    state?: object;
}

const ToListButtonVertical = (props: ToListButtonProps) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                "&:hover": {
                    cursor: "pointer",
                },
                flexShrink: 0,
                color: "secondary.main",
            }}
            onClick={() => {
                if (props.preNavigate) props.preNavigate();
                navigate(props.navigateUrl, { state: { ...props.state } });
            }}
        >
            <Typography variant="h6" sx={{ mr: 0, fontWeight: "bold" }}>
                一覧
            </Typography>
            <KeyboardDoubleArrowRightIcon />
        </Box>
    );
};

export default ToListButtonVertical;
